import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import Message from "./Message";
import { t } from "i18next";

/**
 * Conversation Tab component to display the messages of a conversation.
 * @param {Object} conversation - The conversation object containing messages.
 * @param {Object} resource - The resource configuration.
 * @return {JSX.Element} The rendered ConversationTab component.
 */
const ConversationTab = ({ conversation, resource }) => {
	const conversationHasMessages =
		!lod_.isEmpty(conversation?.messages) && !lod_.isNil(conversation?.messages);

	if (lod_.isNil(conversation)) {
		return (
			<MDBox p={2} textAlign="center">
				{t("FORMS.RESOURCE.PHONECALL.noConversationAvailable")}
			</MDBox>
		);
	}

	return (
		<MDBox
			mt={1}
			style={{
				overflowY: "auto"
			}}
		>
			{conversationHasMessages && (
				<MDBox
					borderRadius="md"
					p={1}
					style={{
						backgroundColor: "rgb(236 236 236)",
						overflowY: "auto"
					}}
				>
					{conversation.messages.map((message, index) => (
						<Message key={index} message={message} />
					))}
				</MDBox>
			)}
		</MDBox>
	);
};

export default ConversationTab;
